export * from './angularfire2';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/angularfire2/index.js
// module id = ../../../../angularfire2/index.js
// module chunks = 3